module.exports = __webpack_public_path__ + "img/reportHead.8d71784d.png";